export class TopMentionsMetadataModel {
    mediaType: boolean = false;
    outlet: boolean = false;
    sentiment: boolean = false;
    publishedDate: boolean = false;
    author: boolean = false;
    audienceReach: boolean = false;
    ave: boolean = false;
    location: boolean = false;
    wordCount: boolean = false;
    duration: boolean = false;
    keywords: boolean = false;
    domainAuthority: boolean = false;
}
